import { NodoDto } from "@/api";
import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

type InfoItemProps = {
  label: string;
  value: string;
};

function InfoItem({ label, value }: InfoItemProps) {
  return (
    <Box>
      <Typography variant="caption">{label}</Typography>
      <Typography variant="h4">{value}</Typography>
    </Box>
  );
}

export function GFL_TH_4000_Info({ nodo }: { nodo: NodoDto }) {
  const { t } = useTranslation();
  const info = nodo.dispositivoLastInfo ?? {};

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InfoItem
            label="Contaore ricircolo TFL700 parziale"
            value={info.ctoretflp ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InfoItem
            label="Contaore ricircolo TFL700 totale"
            value={info.ctoretfltot ?? t("valori.nd")}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InfoItem
            label="Contaore travaso HC400 parziale"
            value={info.ctorethcp ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InfoItem
            label="Contaore travaso HC400 totale"
            value={info.ctorethctot ?? t("valori.nd")}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InfoItem
            label="Contaore scarico HC400 parziale"
            value={info.ctoreshcp ?? t("valori.nd")}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InfoItem
            label="Contaore scarico HC400 totale"
            value={info.ctoreshctot ?? t("valori.nd")}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
